<template>
  <div v-if="!!phaseData && isCSU">
    <div :class="warningInfo.class" class="mb-4" v-if="warningInfo.text">
      <field-label label="Atenção:">
        <p class="mb-0">{{ warningInfo.text }}</p>
      </field-label>
    </div>
    <field-label label="Próximos passos:">
      <v-checkbox
        label="Iniciar/Otimizar posologia de anti-histamínicos"
        v-model="phaseData.optimize"
        hide-details
        @change="clearOmalizumabe"
      />
      <v-checkbox
        label="Adicionar Omalizumabe ao anti-histamínico*"
        v-model="phaseData.omalizumabe"
        hide-details
        @change="setOptimize"
      />
      <span class="ml-8 checkbox-info"
        >*Omalizumabe se aplica someste a UCE. A posologia é de 300mg a cada 4 semanas</span
      >
    </field-label>
    <field-label class="mt-8" label="Anotações">
      <text-area :readonly="disabled" :max-length="2000" v-model="phaseData.notes" />
    </field-label>
  </div>
  <div v-else>
    {{ isCSU }}
    Essa fase é reservada para pacientes com diagnóstico de Urticária Crônica Espontânea. No caso de outros
    diagnósticos, <a @click="nextPhase">vá para a próxima fase.</a>
  </div>
</template>
<script>
import BasePhase from '@/components/AttendanceForm/general/phase/BasePhase.vue'
import FieldLabel from '@/components/FieldLabel.vue'
import TextArea from '@/components/TextArea.vue'
import { createNamespacedHelpers } from 'vuex'

const { mapActions: attendanceActionsMap, mapGetters: attendanceGettersMap } = createNamespacedHelpers('attendance')

export default {
  components: { FieldLabel, TextArea },
  extends: BasePhase,
  data() {
    return {}
  },
  computed: {
    ...attendanceGettersMap(['getPhaseDataByKey', 'attendancePatient']),
    diseaseActivityPhaseData() {
      return this.getPhaseDataByKey('atividade_doenca')
    },
    isCSU() {
      const diagnosis = this.getPhaseDataByKey('diagnostico')
      return (
        this.$moment().diff(diagnosis.data_sintomas, 'weeks') > 6 &&
        (diagnosis?.sintomas_induziveis.value === 'NAO' || diagnosis?.teste_provocacao === false)
      )
    },
    warningInfo() {
      const uct = parseInt(this.diseaseActivityPhaseData?.uct?.value) || null
      const uas7 = parseInt(this.diseaseActivityPhaseData?.uas7?.value) || null

      if (uct !== null && uas7 !== null) {
        if (uct >= 12 && uct <= 15 && uas7 > 6) {
          return {
            text: 'Paciente ainda não está totalmente controlado. Otimizar o tratamento e vitar triggers.',
            class: 'danger',
          }
        }
        if (uct < 12 || uas7 > 6) {
          return {
            text: 'Paciente fora de controle. Otimizar posologia ou mudança de terapia.',
            class: 'danger',
          }
        }
        if (uct >= 12 && uct <= 15 && uas7 <= 6) {
          return {
            text: 'Paciente está bem controlado mas pode otimizar o tratamento evitando triggers como Stress e AINEs, utilizando regularmente o tratamento, entre outros.',
            class: 'danger',
          }
        }
        if (uct === 16 && uas7 <= 6) {
          return {
            text: 'Parabéns! O Paciente está bem controlado. Manutenção ou diminuição de doses até a mínima necessária são opções de conduta.',
            class: 'safe',
          }
        }
      }
      if (!uct && uas7 <= 6) {
        return {
          text: 'O paciente está bem controlado. Calcular UCT pode te trazer ainda mais informações sobre essa situação.',
          class: 'attention',
        }
      }
      if (uct >= 12 && uct <= 16 && !uas7) {
        return {
          text: 'O paciente está com um bom controle da doença. Calcular UAS7 pode te trazer ainda mais informações sobre essa situação.',
          class: 'attention',
        }
      }
      return {
        text: null,
        class: null,
      }
    },
  },
  methods: {
    ...attendanceActionsMap(['nextPhase']),
    getDefaultData() {
      const data = {
        optimize: false,
        omalizumabe: false,
        notes: null,
      }
      return data
    },
    setOptimize() {
      if (this.phaseData.omalizumabe) {
        this.phaseData.optimize = true
      }
    },
    clearOmalizumabe() {
      if (!this.phaseData.optimize) {
        this.phaseData.omalizumabe = false
      }
    },
  },
  mounted() {},
}
</script>

<style scoped>
.checkbox-info {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  letter-spacing: 0.04em;
  color: #78909c;
}
.danger,
.safe,
.attention {
  width: 100%;
  border-width: 2px;
  border-style: solid;
  border-radius: 5px;
  padding: 12px 16px;
  box-shadow: 0px 4px 3px 1px rgba(0, 0, 0, 0.15);
}
.danger {
  border-color: #ff5252;
}
.danger p {
  color: #ff5252;
}
.safe {
  border-color: #60cd0b;
}
.safe p {
  color: #60cd0b;
}
.attention {
  border-color: #1976d2;
}
.attention p {
  color: #1976d2;
}
</style>
